import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";

// Handles scroll on route/hash changes (needed because Lenis + React Router
// don't reset scroll on navigation nor scroll to hash sections by default).
export const ScrollManager = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            scrollToSection(hash);
            return;
        }

        const lenis = window.__lenis;
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};
